import type { HttpErrorResponse } from '@angular/common/http';

import { createEntityCollectionStore, getEntityCollectionActions } from '@core/ngrx-legacy';
import type { FullSearchCandidatesResponse, FullSearchParams } from '@core/search-types';

export interface SearchCandidatesState {
  id: string;
  data: FullSearchCandidatesResponse;
}

const idSelector = (entity: { id: string }) => entity.id;
const { actions, selectors, reducer, namespace } =
  createEntityCollectionStore<SearchCandidatesState>()('SearchCandidates', {
    idSelector,
    customActions: adapter => {
      const defaultActions = getEntityCollectionActions(adapter, idSelector);
      return {
        fetchCandidates: (state, payload: { params: FullSearchParams; id: string }) =>
          adapter.markAsPending(state, { entities: [payload.id], scope: null }),
        fetchCandidatesSuccess: (state, payload: { data: SearchCandidatesState }) =>
          defaultActions.fetchOneSuccess(state, payload),
        fetchCandidatesFailed: (state, payload: { error: HttpErrorResponse; id: string }) =>
          defaultActions.fetchOneFailed(state, payload),
      };
    },
  });

const { fetchCandidates, fetchCandidatesSuccess, fetchCandidatesFailed } = actions;
const SearchCandidatesActions = {
  fetchCandidates,
  fetchCandidatesSuccess,
  fetchCandidatesFailed,
};

export {
  SearchCandidatesActions,
  selectors as SearchCandidatesSelectors,
  reducer as SearchCandidatesReducer,
  namespace as SearchCandidatesNamespace,
};
